import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  Grid,
  Typography,
  Paper,
  Box,
  Snackbar,
  IconButton
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import CustomerDataFreshness from "../CustomerReport/CustomerDataFreshness";
import ProductMatchesPerGroup from "../CustomerReport/ProductMatchesPerGroup";
import BannersPerProduct from "../CustomerReport/BannersPerProduct";
import ProductsAtEachBanner from "../CustomerReport/ProductsAtEachBanner";
import PriceRecordsByWeekTable from '../CustomerReport/PriceRecordsByWeekTable';
import CacheUpdateInfo from './CacheUpdateInfo';
import ProjectHealthSummaryCard from '../CustomerReport/ProjectHealthSummaryCard';
import axios from "axios";
import envConfig from "../../../bin/env.config";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function DialogMetrics({ open, onClose, project }) {
  const token = useSelector((state) => state.session.token);
  const [last_cache_update, setLastCacheUpdate] = useState(null);
  const [showError, setShowError] = useState(false);
  const prevUserTypeIdRef = useRef(null);

  const checkCacheReport = async () => {
    try {
      const response = await axios.post(
        `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/check-report-data`,{
          user_type_id: project.user_type_id,
          report_name: 'customer_project_metrics'
        },  
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setLastCacheUpdate(response.data.data);
      if (response.data.data && response.data.data.id === 0) {
        setShowError(true);
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error checking cache report:", error);
      setShowError(true);
      return false;
    }
  };

  useEffect(() => {
    if (!open) return;
    
    if (prevUserTypeIdRef.current !== project.user_type_id) {
      checkCacheReport();
      prevUserTypeIdRef.current = project.user_type_id;
    }
  }, [open, project.user_type_id]);

  const handleErrorClose = () => {
    setShowError(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth='lg'
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      aria-labelledby="Project Metrics"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>{project && `${project.name} Metrics - user type: ${project.user_type_id}`}</span>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <CacheUpdateInfo lastCacheUpdate={last_cache_update} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ProjectHealthSummaryCard project={project} />
          </Grid>
          <Grid item xs={12}>
            <CustomerDataFreshness project={project} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProductMatchesPerGroup project={project} />
          </Grid>
          <Grid item xs={12} md={6}>
            <BannersPerProduct project={project} />
          </Grid>
          <Grid item xs={12}>
            <ProductsAtEachBanner project={project} />
          </Grid>
          <Grid item xs={12}>
            <PriceRecordsByWeekTable project={project} />
          </Grid> 
        </Grid>
        {/* Placeholder for metrics dashboard */}
        {/* <div style={{ minHeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#888' }}>
          Metrics dashboard coming soon...
        </div> */}
      </DialogContent>
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleErrorClose}
        message="No cache report available. Please check."
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Dialog>
  );
} 